export default "__VITE_ASSET__rU3HiywN1hgln5fsonHW0Q__"